import React, {Component} from 'react';
import PropTypes from 'prop-types';
import './PriorConsentsList.css';
import _ from 'lodash';
import {Table, Button} from 'reactstrap';
import {sharedLabelsPath} from "../../../../reducers/common/localization";
import {Redirect} from 'react-router-dom';
import PaginationPendingConsents from '../../../commonComponents/paginationComponent/PaginationPendingConsents.container';
import IconContainer from "../../../commonComponents/iconContainer/IconContainer";
import {AVAILABLE_PRIOR_CONSENT_TYPES} from "../../../../constants/constants";
import moment from 'moment';
import FormWrapper from "../../../commonComponents/formWrapper/FormWrapper.container";
import RemovePriorConsentModal from "../../removePriorConsentModal/RemovePriorConsentModal.container";

export const TARGET_TYPE_LABEL_PATH = {
    [AVAILABLE_PRIOR_CONSENT_TYPES.ANYONE]: 'prior_consents.anyone_label',
    [AVAILABLE_PRIOR_CONSENT_TYPES.ORGANIZATION]: sharedLabelsPath.org_label,
    [AVAILABLE_PRIOR_CONSENT_TYPES.PERSON]: 'consents.person_label'
};

class PriorConsentsList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            redirect: false,
            selectedPriorConsentId: null,
            priorConsentToRemove: null
        }
    }

    componentDidMount() {
        this.props.onMount();
    }

    componentWillUnmount() {
        this.props.onUnmount();
    }

    render() {
        if (this.state.redirect) {
            return (
                <Redirect to='/add-prior-consent' push/>
            );
        }

        if (!_.isNil(this.state.selectedPriorConsentId)) {
            return (
                <Redirect to={'/edit-prior-consent?id=' + this.state.selectedPriorConsentId} push/>
            );
        }

        return (
            <div className='prior-consents-list-container'>
                <FormWrapper successMessage={_.get(this.props.translation, 'prior_consents.remove_prior_consent_success_message')}>
                    <h4 className='page-label'>{_.get(this.props.translation, 'prior_consents.prior_consents_label')}</h4>
                    {this.props.addingDisabled ? null :
                        <div className='add-prior-consent-container'>
                            <Button className='olive-green-btn' onClick={this.handleAddButtonClick}>
                                {_.get(this.props.translation, sharedLabelsPath.add_button)}
                            </Button>
                        </div>}
                    <PaginationPendingConsents/>
                    {this.renderTable()}
                    <RemovePriorConsentModal data={this.state.priorConsentToRemove} onCancelRemoving={this.resetPriorConsentToRemove}/>
                </FormWrapper>
            </div>
        );
    }

    renderTable = () => {
        if (this.props.loading) {
            return (
                <div className="prior-consents-list-status-message-container">
                    <h6>{_.get(this.props.translation, sharedLabelsPath.fetching_message)}</h6>
                </div>
            );
        }
        if (_.isNil(this.props.data) || this.props.data.length === 0) {
            return (
                <div className="prior-consents-list-status-message-container">
                    <h6>{_.get(this.props.translation, 'prior_consents.prior_consents_no_data_label')}</h6>
                </div>
            );
        }

        return (
            <Table className='prior-consents-list-table'>
                <thead>
                <tr>
                    <th>{_.get(this.props.translation, 'prior_consents.target_type_label')}</th>
                    <th>{_.get(this.props.translation, 'prior_consents.target_data_label')}</th>
                    <th>{_.get(this.props.translation, 'prior_consents.auto_grant_till_label')}</th>
                    <th>{_.get(this.props.translation, 'prior_consents.duration_label')}</th>
                    {this.props.editingDisabled ? null : <th/>}
                    <th/>
                </tr>
                </thead>
                <tbody>
                {this.renderPendingConsentsData()}
                </tbody>
            </Table>
        )
    };

    renderPendingConsentsData = () => {
        return _.map(this.props.data, (consentData, index) => (
            <tr className={"prior-consents-list-row " + (this.props.editingDisabled ? 'disabled ' : '') + (moment().startOf('day').isAfter(moment(consentData.enabledTill)) ? 'expired ' : '')}
                key={index} onClick={this.handleRowClick(consentData.id)}>
                <td className='target-type-td'
                    data-th={_.get(this.props.translation, 'prior_consents.target_type_label') + ':'}>
                    {_.get(this.props.translation, TARGET_TYPE_LABEL_PATH[consentData.targetType])}
                </td>
                <td className='target-data-td'
                    data-th={_.get(this.props.translation, 'prior_consents.target_data_label') + ':'}>
                    {this.getTargetData(consentData)}
                </td>
                <td className='auto-grant-till-td'
                    data-th={_.get(this.props.translation, 'prior_consents.auto_grant_till_label') + ':'}>
                    {moment(consentData.enabledTill).format('LL')}
                </td>
                <td className='duration-td'
                    data-th={_.get(this.props.translation, 'prior_consents.duration_label') + ':'}>
                    {this.getGrantedPeriodDays(consentData.grantedPeriodDays)}
                </td>
                {this.props.editingDisabled ? null :
                    <td className='edit-icon-td' onClick={this.handleRowClick(consentData.id)}>
                        <IconContainer icon='create' key={consentData.id} title={_.get(this.props.translation, 'prior_consents.edit_prior_consent_label')}/>
                    </td>}
                <td className='remove-icon-td' onClick={this.handleRemoveIconClick(consentData)}>
                    <IconContainer icon='trash' key={consentData.id} title={_.get(this.props.translation, 'prior_consents.remove_prior_consent_label')}/>
                </td>
            </tr>
        ))
    };

    getTargetData = (consentData) => {
        switch (consentData.targetType) {
            case AVAILABLE_PRIOR_CONSENT_TYPES.PERSON:
                return (
                    <span className='target-data'>
                        {!_.isEmpty(consentData.metadata.firstName) && !_.isEmpty(consentData.metadata.lastName) ?
                            consentData.metadata.firstName + ' ' + consentData.metadata.lastName + '\n' : ''}
                        <a href={"mailto:" + consentData.targetId}>{consentData.targetId}</a>
                    </span>
                );
            case AVAILABLE_PRIOR_CONSENT_TYPES.ORGANIZATION:
                return (
                    <span className='target-data'>
                        {consentData.targetId}
                    </span>
                );
            default:
                return;
        }
    };

    getGrantedPeriodDays = (periodDays) => {
        let label = periodDays === 1 ? _.get(this.props.translation, 'prior_consents.day_label') : _.get(this.props.translation, 'prior_consents.days_label');

        return periodDays + ' ' + label;
    };

    handleAddButtonClick = () => {
        this.setState({redirect: true});
    };

    handleRowClick = (id) => () => {
        if (this.props.editingDisabled) {
            return;
        }

        this.setState({selectedPriorConsentId: id});
    };

    handleRemoveIconClick = (data) => (e) => {
        e.stopPropagation();
        this.setState({priorConsentToRemove: data});
        this.props.onRemoveIconClick();
    };

    resetPriorConsentToRemove = () => {
        this.setState({priorConsentToRemove: null});
    }
}

PriorConsentsList.propTypes = {
    translation: PropTypes.object.isRequired,
    data: PropTypes.array,
    addingDisabled: PropTypes.bool,
    editingDisabled: PropTypes.bool,
    onMount: PropTypes.func.isRequired,
    onRemoveIconClick: PropTypes.func.isRequired,
    onUnmount: PropTypes.func.isRequired
};

export default PriorConsentsList;



// WEBPACK FOOTER //
// ./src/components/consentManagement/consentsList/priorConsentsList/PriorConsentsList.js